import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useDispatch, useSelector } from 'react-redux';
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  TextField,
  MenuItem,
  CircularProgress,
} from '@mui/material';

const CongeladoCreacionHelados = () => {
  const { user } = useSelector(state => state.auth);  
  const [helados, setHelados] = useState([]);
  const [ptpr, setPtpr] = useState("");
  const [tipo, setTipo] = useState("");
  const [cantidad, setCantidad] = useState("");
  const [Comentario2, setComentario2] = useState("");
  const [availableItems, setAvailableItems] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  // Estado para los sabores disponibles (ahora almacenamos objetos completos)
  const [saboresDisponibles, setSaboresDisponibles] = useState([]);

  // Estado para los materiales a producir
  const [materialesAProducir, setMaterialesAProducir] = useState([]); 

  const [existenciaHelados, setExistenciaHelados] = useState([]); 

  const [busquedaSabor, setBusquedaSabor] = useState(""); 

  const [holamundo, setHolaMundo] = useState("")


  const tipoOptions = ["Vaso", "Litro"]; 

    const [bodegaSeleccionada, setBodegaSeleccionada] = useState('');

  // Lista de productos existentes (simulada)
  const productosExistentes = [
    { ItemCode: "PTPR02466", ItemName: "VASO DE 6 ONZAS CONGELADO PEPITORIA" },
    { ItemCode: "PTPR02467", ItemName: "VASO DE 6 ONZAS CONGELADO ARÁNDANO" },
  ];


  const tiendasPrecargadas = [
    { id: 1, nombre: 'TZ10' },
    { id: 2, nombre: 'TPRR' },
    { id: 3, nombre: 'TSCR' },
    { id: 4, nombre: 'TCSV' },
    { id: 5, nombre: 'TMIR' },
    { id: 6, nombre: 'TXLA' }
  ];

  const saboresFiltrados = saboresDisponibles.filter(sabor =>
    sabor.ItemName.toLowerCase().includes(busquedaSabor.toLowerCase())
  );
  const agregarHelado = () => {
    if (ptpr && cantidad) {
      const saborSeleccionado = saboresDisponibles.find((sabor) => sabor.ItemCode === ptpr);
     
      // Verificar si en la lista de helados ya existe un código de fabricación
      const existeCodigoFabricacion = helados.some((helado) => helado.codigo);
  
      if (existeCodigoFabricacion) {
        // Si existe un código de fabricación, limpiar la tabla
        setHelados([]); // Limpiar la lista de helados
        setSaboresDisponibles(availableItems); // Restablecer sabores disponibles
        setHolaMundo("FALSE")
        alert("Se encontró un código de fabricación en la lista. La tabla ha sido limpiada.");

      } else {
        // Si no existe un código de fabricación, agregar el helado normalmente
        setHelados([...helados, { ItemCode: saborSeleccionado.ItemCode, ptpr: saborSeleccionado.ItemName, cantidad }]);
        setSaboresDisponibles(saboresDisponibles.filter((sabor) => sabor.ItemCode !== ptpr));
        setPtpr("");
        setCantidad("");
      }
    }
  };

  const quitarHelado = (index) => {
    const heladoEliminado = helados[index];
    setHelados(helados.filter((_, i) => i !== index));
    setSaboresDisponibles([...saboresDisponibles, { ItemCode: heladoEliminado.ItemCode, ItemName: heladoEliminado.ptpr }]);
  };

 
  

  const realizarTraslado = async () => {
    setIsLoading(true); // Activar el estado de carga
  
    try {
      // Crear una copia de los helados para actualizarla
      let heladosActualizados = [...helados];
  
      // Iterar sobre cada helado y enviar la solicitud
      for (let i = 0; i < heladosActualizados.length; i++) {
        const codigo = await handleSend(heladosActualizados[i]); // Enviar cada helado y obtener el código
        heladosActualizados[i].codigo = codigo;  
        // Agregar el código al helado
      }
  
      // Actualizar la lista de helados con los códigos
      setHolaMundo("TRUE");
      setHelados(heladosActualizados);
      fetchData2(bodegaSeleccionada);
      fetchData3(bodegaSeleccionada);

  
      alert("Fabricación completada con éxito.");
    } catch (error) {
      console.error("Error al realizar la fabricación:", error);
      alert("Hubo un error al realizar la fabricación.");
    } finally {
      setIsLoading(false); // Desactivar el estado de carga
    }
  };


  const handleSend = async (helado) => {
    const datos = {
      Token: 'LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY',
      Ambiente: 'DESA',
      Dispositivo: {
        Marca: 'SAMSUNG',
        Modelo: 'S22002B',
        Version: 'Android 18.125',
        McAdress: null,
        PowerStatus: '84%',
        WifiStatus: 'Conected to iphone de Mauricio',
        GPSStatus: 'ON',
        GPS: '321|-485|321',
      },
      User: {
        Codigo: '',
        UserNickName: 'pierril',
      },
      Metodo: {
        NombreMetodo: 'OrderProduction',
        Datos_Recibidos: JSON.stringify({
          Producto: helado.ItemCode, // Usar el ItemCode del helado
          Quantity: helado.cantidad, // Usar la cantidad del helado
          Tienda: bodegaSeleccionada, // Valor fijo
          Comentarios: Comentario2 || "Sin comentarios", // Usar el comentario o un valor por defecto
        }),
        Datos_Generados: '',
      },
    };
  
    console.log(datos);
    try {
      const response = await fetch('https://appcorp.parma.com.gt/API/ReceptorDatos', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(datos),
      });
  
      const data = await response.json();
      console.log('Respuesta de la API:', data);
  
      // Extraer el código de datos_Generados
      const datosGenerados = JSON.parse(data.datos_Generados);
      const codigo = datosGenerados.Codigo; // Asume que el código viene en este campo
  
      return codigo; // Devolver el código para usarlo en realizarTraslado
    } catch (error) {
      console.error('Error al enviar transferencia:', error);
      throw error; // Propagar el error para manejarlo en realizarTraslado
    }
  };
  const getBodegasFiltradas = () => {
    if (tiendasPrecargadas.some(tienda => tienda.nombre === user.usuario)) {
      // Si coincide con una tienda, excluirla de la lista
      return tiendasPrecargadas.filter(tienda => tienda.nombre !== user.usuario);
    }
    // Si no coincide, mostrar todas las bodegas
    return tiendasPrecargadas;
  };

  const fetchData = (bodega) => {
    setIsLoading(true); // Indicador de carga
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ListaProductosFabricacion",
        Datos_Recibidos: `{"Fecha":"20250114","Sala":"${bodega}"}`,
      },
    };

    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    fetch(fetchDataUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
          const decodedString = JSON.parse(data.datos_Generados);
          setAvailableItems(decodedString.PRODUCTOS);
          // Actualizar sabores disponibles con los objetos completos
          setSaboresDisponibles(decodedString.PRODUCTOS);
        } catch (error) {
          console.error("Error al procesar datos_Generados:", error);
        }
      })
      .catch((error) => console.error("Error en la solicitud:", error))
      .finally(() => setIsLoading(false));
  };

  const fetchData2 = (bodega) => {
    setIsLoading(true); // Indicador de carga
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ListaComponentesFabricacion",
        Datos_Recibidos: `{"BODEGA":"${bodega}"}`,
      },
    };
console.log(datos)
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    

    fetch(fetchDataUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
          const decodedString = JSON.parse(data.datos_Generados);
          console.log(decodedString);
          // Actualizar el estado con los materiales a producir
          setMaterialesAProducir(decodedString.STOCK);
        } catch (error) {
          console.error("Error al procesar datos_Generados:", error);
        }
      })
      .catch((error) => console.error("Error en la solicitud:", error))
      .finally(() => setIsLoading(false));
  }; 

  const fetchData3 = (bodega) => {
   setIsLoading(true); // Indicador de carga
    const datos = {
      Token: "LJKNFUH2FWEJBAEFFFFFKJ VGDEA003CSFCAQWEUIRRRRRRRRRRRADFYGBIFHVBESRNYHIOPWJROTY4WY",
      Ambiente: "DESA",
      Dispositivo: {
        Marca: "SAMSUNG",
        Modelo: "S22002B",
        Version: "Android 18.125",
        McAdress: null,
        PowerStatus: "84%",
        WifiStatus: "Conected to iphone de Mauricio",
        GPSStatus: "ON",
        GPS: "321|-485|321",
      },
      Usr: {
        Codigo: "",
        UserNickName: "pierril",
      },
      DatosMetodo: {
        NombreMetodo: "ListaHeladoCongeladoSalas",
        Datos_Recibidos: `{"BODEGA":"${bodega}"}`,
      },
    };
console.log(datos)
    const fetchDataUrl = `https://appcorp.parma.com.gt/API/ReceptorDatos?Datos=${encodeURIComponent(
      JSON.stringify(datos)
    )}`;

    fetch(fetchDataUrl)
      .then((response) => response.json())
      .then((data) => {
        try {
         const decodedString = JSON.parse(data.datos_Generados);
          console.log(decodedString);
          // Actualizar el estado con los materiales a producir
         // setMaterialesAProducir(decodedString.STOCK);
         setExistenciaHelados(decodedString.STOCK)
        } catch (error) {
          console.error("Error al procesar datos_Generados:", error);
        }
      })
      .catch((error) => console.error("Error en la solicitud:", error))
      .finally(() => setIsLoading(false));
  };

  useEffect(() => { 
    if (bodegaSeleccionada) {
      fetchData(bodegaSeleccionada);
      fetchData2(bodegaSeleccionada);
      fetchData3(bodegaSeleccionada);

    }

   
  }, [bodegaSeleccionada]);

   useEffect(() => {
      const bodegaInicial = tiendasPrecargadas.find(tienda => tienda.nombre === user.usuario);
      if (bodegaInicial) {
        setBodegaSeleccionada(bodegaInicial.nombre);
      }
    }, [user]);
    
    const usuarioEnTiendasPrecargadas = tiendasPrecargadas.some(
      (tienda) => tienda.nombre === user.usuario
    );


  return (
    <div className="container mt-4">
      <h1>ENVASADO DE HELADOS</h1>
      <br />
      <br />
      <div className="row"> 
      <div style={{ padding: '1rem' }}>
    {/* Solo mostrar si el usuario NO está en tiendasPrecargadas */}
    {!usuarioEnTiendasPrecargadas && (
      <div style={{ marginBottom: '1rem' }}>
        <h3>Seleccionar Bodega</h3>
        <TextField
          select
          label="Bodega"
          value={bodegaSeleccionada}
          onChange={(e) => setBodegaSeleccionada(e.target.value)}
          style={{ width: '300px' }}
        >
          {/* Aquí irían las opciones */}
		    {getBodegasFiltradas().map((bodega) => (
      <MenuItem key={bodega.id} value={bodega.nombre}>
        {bodega.nombre}
      </MenuItem>
    ))}
        </TextField>
      </div>
    )}
  </div>


        {/* Columna para agregar nuevos helados */}
        <div className="col-md-6">
          <div className="card shadow-sm">
            <div className="card-body">
              <h2 className="text-center mb-4">Envasado de Helado Congelado</h2>

              <TextField
        label="Buscar Sabor"
        variant="outlined"
        fullWidth
        value={busquedaSabor}
        onChange={(e) => setBusquedaSabor(e.target.value)}
        style={{ marginBottom: "10px" }}
      />

      {/* Select para elegir el sabor */}
      <TextField
        select
        label="Sabor"
        value={ptpr}
        onChange={(e) => setPtpr(e.target.value)}
        fullWidth
      >
        {saboresFiltrados.map((sabor) => (
          <MenuItem key={sabor.ItemCode} value={sabor.ItemCode}>
            {sabor.ItemName}
          </MenuItem>
        ))}
      </TextField>

              <div className="form-group">
                <label>Cantidad:</label>
                <input
                  type="number"
                  className="form-control"
                  placeholder="Cantidad"
                  value={cantidad}
                  onChange={(e) => setCantidad(e.target.value)}
                />
              </div> 

              <div className="form-group">
                <label>Comentario:</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Nombre Personal "
                  value={Comentario2}
                  onChange={(e) => setComentario2(e.target.value)}
                />
              </div>

              <button
                className="btn btn-primary btn-block"
                onClick={agregarHelado}
                disabled={!ptpr || !cantidad}
              >
                Agregar Helado
              </button>
            </div>

            <div className="card-body">
  <h3 className="mt-4">Nuevos Helados Agregados</h3>
  <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Codigo</th>
          <th>Nombre Producto</th>
          <th>Cantidad</th>
          <th>No.OF</th>
          <th>Acciones</th>
         
        </tr>
      </thead>
      <tbody>
        {helados.map((helado, index) => (
          <tr key={index}>
            <td>{helado.ItemCode}</td>
            <td>{helado.ptpr}</td>
            <td>{helado.cantidad} </td> 
            <td>{helado.codigo || "Pendiente"}</td> 
            <td>
              {/* Ocultar el botón si existe un código de fabricación */}
              {!helado.codigo && (
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => quitarHelado(index)}
                >
                  Quitar
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
  <br />
  <button
    className="btn btn-success btn-block"
    onClick={realizarTraslado}
    disabled={helados.length === 0 || isLoading || holamundo === 'TRUE' }
  > 
    {isLoading ? "Enviando..." : ""}
    Realizar Envzado
  </button>
</div>
          </div>
        </div>

        {/* Columna para lista de materiales a producir y existencias */}
        <div className="col-md-6">
        <div className="card shadow-sm">
        <div className="card-body">
  <h2 className="text-center mb-4">Materiales a usar para envazar </h2>
  <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
    <table className="table table-striped table-bordered">
      <thead>
        <tr>
          <th>Código</th>
          <th>Nombre del Producto</th>
          <th>Stock Disponible</th>
        </tr>
      </thead>
      <tbody>
        {materialesAProducir.map((material) => (
          <tr key={material["Codigo del Producto"]}>
            <td>{material["Codigo del Producto"]}</td>
            <td>{material["Nombre del Producto"]}</td>
            <td>{material["Stock Disponible Cocina"]}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
</div>

</div>
          <br />
          <br />
          <hr />
          <div className="card shadow-sm">
        <div className="card-body">
          <h2 className="text-center mb-4">Existencias de Envasado</h2>
          <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
            <table className="table table-striped table-bordered">
              <thead>
                <tr>
                  <th>Código</th>
                  <th>Nombre del Producto</th> 
                  <th>Cantidad</th>
                </tr>
              </thead>
              <tbody>
                {existenciaHelados.map((producto) => (
                  <tr key={producto["Codigo del Producto"]}>
                    <td>{producto["Codigo del Producto"]}</td>
                    <td>{producto["Nombre del Producto"]}</td>
                    <td> {producto["Stock Disponible Cocina"]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
        </div>
      </div>
    </div>
  );
};

export default CongeladoCreacionHelados;